<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<style scoped lang="scss">
  .lists{
    display: flex;
    justify-content: space-around;
    text-align: center;
    p{
      margin-top: 10px;
    }
  }
  .container10{
    margin-top: 80px;
  }
  .container10 h1{
    font-size: 70px;
    color: #014492;
  }
  .cons{
    display: none;
  }
  .container10 h2{
    font-size: 40px;
    color: #014492;
  }
  .container10 .a{
    width: 800px;
    height: 6px;
    margin-top: 30px;
    margin-bottom: 40px;
    background: #ccc;
    position: relative;
  }
  .container10 .a span{
    width: 50px;
    height: 6px;
    position: absolute;
    left: 0;
    top: 0;
    background: #014492;
  }
  .no-indent {
    .desc{
      text-indent: 0
    }
  }
  .wrap-tec .lists li {
    width: 33.3%;
  }
  @media screen and (max-width: 640px) {
    .wrap-tec .lists li {
      width: 100% !important;
      p {
        margin: 5px auto !important;
      }
    }
  }
</style>
<template>
  <div class="wrap wrap-tec">
<!--    <div class="banner">-->
<!--      <img src="@/assets/images/banner_17.png" class="img-fluid">-->
<!--      <div class="info">-->
<!--        <div class="container">-->
<!--          <h1>原核转录组测序</h1>-->
<!--          <h2 class="mt10">Prokaryotic transcriptome sequencing</h2>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="container container10">
      <h1>原核转录组测序</h1>
      <h2 class="mt10">Prokaryotic Transcriptome Sequencing</h2>
      <div class="a"><span></span></div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;">
      <bread></bread>
    </div>
    <section class="container">
      <p class="desc">
        原核转录组测序是针对原核生物展开的转录组测序服务，基于高通量测序平台，构建链特异性文库，研究原核生物在某个时期或者某种环境条件下转录出来的所有mRNA。由于原核生物mRNA没有polyA尾结构，需要采用去除rRNA的方法构建文库，擎科生物针对不同的研究物种采取有效的方法去除rRNA，保证数据质量。      
      </p>
      <en-title title="应用领域" enTitle="Application" />
      <application-icon :iconList="iconList" :lines="1" menuTitle="原核转录组测序"/>
      <en-title title="技术参数" enTitle="Specifications" />
      <ul class="lists">
        <li>
          <img src="@/assets/images/prokaryotic_icon_4.png">
          <h4>测序平台及策略</h4>
          <p>Novaseq PE150</p>
        </li>
        <li>
          <img src="@/assets/images/prokaryotic_icon_8.png">
          <h4>项目周期</h4>
          <p>30个工作日</p>
        </li>
        <!-- <li>
          <img src="@/assets/images/prokaryotic_icon_6.png">
          <h4>测量数据量</h4>
          <p>2 G</p>
        </li> -->
        <li>
          <img src="@/assets/images/prokaryotic_icon_7.png">
          <h4>数据质量</h4>
          <p>Q30＞80% , Q20＞85%</p>
        </li>
      </ul>
      <en-title title="技术路线" enTitle="Testing Workflow" />
      <div class="tc con"><img src="@/assets/images/ngs_second/transcriptome/prokaryotic/prokaryotic_1.png"> </div>
      <div class="tc cons" style="margin-top: 20px;"><img src="@/assets/images/ngs_second/transcriptome/prokaryotic/prokaryotic_1.png"> </div>
      <en-title title="研究内容" enTitle="Bioinformatics Service" />
      <service-table
        :tableColumn="tableColumn"
        :tableData="tableData"
        :headerCellStyle="headerCellStyle"
        :tableSpanMethod="tableSpanMethod"
      />
    </section>
    <new-consult
      title="样本制备与寄样"
      enTitle="Sample Requirement and Shipment"
      :samplingText="samplingText"
      :typeList="['sampling']"
    />
    <!-- <qk-consult type="Virus"/> -->
  </div>
</template>
<script>
import bread from "@/components/bread";
import ServiceTable from "./components/serviceTable";
import ApplicationIcon from "./components/applicationIcon";
export default {
  inject: ['reload'],
  components: {
    bread,
    ServiceTable,
    ApplicationIcon,
  },
  data () {
    return {
      samplingText: "擎科生物原核转录组测序目前接收细菌菌体（无致病性与传染性）与提取好的total RNA。",
      tableColumn: [
        {
          prop: "method1",
          html: true,
        },
        {
          prop: "method2",
          html: true,
        },
      ],
      tableData: [
        {
          method1: `1) 数据产出以及数据质控`,
          method2: `5) 表达量分析
                    <p class="ml17 mt10">5.1 样本相关性分析</p>
                    <p class="ml17 mt10">5.2 基因表达差异分析</p>
                    <p class="ml17 mt10">5.3 差异基因富集分析（GO/KEGG）</p>
                    <p class="ml17 mt10">5.4 差异基因表达模式聚类</p>
                    <p class="ml17 mt10">5.5 差异基因韦恩图</p>`
        },
        {
          method1: `2) 与参考基因组比对`,
        },
        {
          method1: `3) 转录组质量评估（比对率/饱和度/覆盖度分析）`,
        },
        {
          method1: `4) 序列分析
                    <p class="ml17 mt10">4.1 GO功能注释</p>
                    <p class="ml17 mt10">4.2 KEGG功能注释</p>
                    <p class="ml17 mt10">4.3 COG功能注释</p>
                    <p class="ml17 mt10">4.4 SNP/INDEL分析</p>`
        },
      ],
      iconList: [
        {
          img:'ngs_second/transcriptome/prokaryotic/icon_1',
          title:'研究细菌与环境变化的\n应答机制、细菌致病机制',
        },
        {
          img:'ngs_second/transcriptome/prokaryotic/icon_2',
          title:'研究细菌表型差异的\n转录调控机制',
        },
        {
          img:'ngs_second/transcriptome/prokaryotic/icon_3',
          title:'完善微生物转录组信息，如\n转录本结构、非编码RNA等',
        },
      ],
    }
  },
  created() {
    this.reload()
  },
  methods: {
    headerCellStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return {
          display: "none",
        };
      }
    },
    tableSpanMethod({ row, column, rowIndex, columnIndex }){
      if (columnIndex === 1) {
        return {
          rowspan: row.method2 ? 4 : 0,
          colspan: row.method2 ? 1 : 0
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/prokaryotic.vue